import { CalculatorInput, CalculatorResult } from '../types/calculator';
import { products } from '../data/products';

export const calculateProfits = (input: CalculatorInput): CalculatorResult => {
  const product = products.find(p => p.id === input.product);
  
  if (!product) {
    throw new Error(`Product ${input.product} not found`);
  }
  
  const { dailyPercentage, monthlyPercentage, quarterlyPercentage, yearlyPercentage } = product.calculatorDefaults;
  
  const dailyProfit = input.amount * (dailyPercentage / 100);
  const monthlyProfit = input.amount * (monthlyPercentage / 100);
  const quarterlyProfit = input.amount * (quarterlyPercentage / 100);
  const yearlyProfit = input.amount * (yearlyPercentage / 100);
  
  return {
    dailyProfit,
    monthlyProfit,
    quarterlyProfit,
    yearlyProfit,
    dailyPercentage,
    monthlyPercentage,
    quarterlyPercentage,
    yearlyPercentage
  };
};

export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2
  }).format(value);
};
